import { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../contexts/EncoreContext";
export function useEncoreContextType(legacyVariant, variant) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.type, config);
  return status === encoreContextStatus.deprecated ? legacyVariant : variant;
}